import { type FC, useContext, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useBoolean } from 'usehooks-ts'

import { Checkbox } from 'base-ui'

import { AuthenticationPasswordRequirementsIndicator } from '../../../authentication'
import { LoginRegistrationRegistrationFormStateContext } from '../../context/LoginRegistrationRegistrationFormStateContext'
import { LoginRegistrationRegistrationFormPasswordInput } from '../LoginRegistrationRegistrationForm/LoginRegistrationRegistrationFormPasswordInput'

export const LoginRegistrationModifyRegistrationPasswordSection: FC = () => {
  const {
    setValue: setPasswordlessRegistrationSelected,
    value: isPasswordlessRegistrationSelected,
  } = useBoolean(false)
  const { registrationFormState } = useContext(
    LoginRegistrationRegistrationFormStateContext,
  )
  const { model } = registrationFormState

  const shouldShowPasswordFieldForRegistration =
    !isPasswordlessRegistrationSelected

  useEffect(() => {
    registrationFormState.setValue(
      isPasswordlessRegistrationSelected,
      model,
      'isPasswordlessRegistrationSelected',
    )
    if (isPasswordlessRegistrationSelected) {
      registrationFormState.setValue('', model, 'password')
    }
  }, [isPasswordlessRegistrationSelected, model, registrationFormState])

  return (
    <>
      <div className="mx-4 flex flex-col items-start self-start rounded-s bg-light-secondary-low py-1">
        <div className="flex items-center gap-2 p-2">
          <Checkbox
            checked={isPasswordlessRegistrationSelected}
            data-qa-id="register-form-password-optional-checkbox"
            id="register-form-password-optional"
            onChange={(event) => {
              setPasswordlessRegistrationSelected(event.target.checked)
            }}
            size="medium"
          />
          <label
            className="text-m text-dark-primary-max"
            htmlFor="register-form-password-optional"
          >
            <FormattedMessage id="registration.passwordless.checkboxLabel" />
          </label>
        </div>
        {isPasswordlessRegistrationSelected ? (
          <p className="mr-4 pl-10 text-m text-dark-primary-max">
            <FormattedMessage id="registration.passwordless.description" />
          </p>
        ) : null}
      </div>

      {shouldShowPasswordFieldForRegistration ? (
        <LoginRegistrationRegistrationFormPasswordInput
          isPasswordRequired
          isStrongPasswordRequired
        />
      ) : null}
      {shouldShowPasswordFieldForRegistration ? (
        <AuthenticationPasswordRequirementsIndicator
          password={model.password}
        />
      ) : null}
    </>
  )
}
